import { createStickyContext } from '@orthly/ui';

export const {
    Provider: ChatStickyProvider,
    useParent: useChatStickyParent,
    useChild: useChatStickyChild,
} = createStickyContext<Date>();
